import zh_CN from './zh_CN';
export default zh_CN;
